import { useCallback, useEffect, useState } from "react";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";
import { VerifyAdmin } from "./VerifyAdmin";
import { SessionView } from "../../firestore/Types/BookingSchema";
import { getUpComingTutorSessions } from "../../firestore/Functions/AdminFunctions";
import { CalendarSession } from "../../components/Calendar/CalendarSession";
import { StatusTag, StatusTagColor, TagSize } from "../../components/Account/StatusTag";
import { LabelText } from "../../components/Common/LabelText";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getTimeSlotFromAndTo, getDurationText } from "../../Utils/TimeSlotUtils";
import { useUtility } from "../../contexts/auth/UtilityContext";
import { useNavigate } from "react-router-dom";

export function UpcomingTutorSessions() {
    const [tutorSessions, setTutorSessions] = useState<SessionView[]>([]);

    const [filteredSessions, setFilteredSessions] = useState<SessionView[]>([]);

    const [selectedSession, setSelectedSession] = useState<SessionView | null>(null);

    const { subjects } = useUtility();

    const navigate = useNavigate();

    const pageSetup = useCallback(async () => {
        const tutorSessions = await getUpComingTutorSessions();
        setTutorSessions(tutorSessions);
    }, []);

    const handleSelectSession = (session: SessionView) => {
        setSelectedSession(session);
    }

    useEffect(() => {
        pageSetup();
    }, [pageSetup]);

    useEffect(() => {
        const newSessions = tutorSessions.sort((a, b) => {
            if (a.SessionTimeStamp.toDate() > b.SessionTimeStamp.toDate()) {
                return 1;
            } else {
                return -1;
            }
        });
        setFilteredSessions(newSessions);
    }, [tutorSessions]);

    const getSubjectName = (subjectID: string) => {
        // Get subject name from subject ID
        for (const subject of subjects) {
            if (subject.Id === subjectID) {
                return subject.SubjectName;
            }
        }
        return "";
    }

    function handleMessageInfoUser(): void {
        navigate(`/messages/?userId=${selectedSession?.StudentId}`);
    }

    function handleMessageInfoTutor(): void {
        navigate(`/messages/?userId=${selectedSession?.TutorId}`);
    }

    return (
        <LoggedInLayoutSelector>
            <VerifyAdmin />
            <div className="main-bg min-h-[90vh]">
                <div className="text-center cal-header">This week's sessions</div>
                <div className="flex flex-row">
                    <div className="flex flex-col w-full">
                        {filteredSessions.map((session, index) => {
                            return <CalendarSession key={index} session={session} showDay onClick={handleSelectSession} />
                        })}
                    </div>
                    <div className="flex flex-col w-full">
                        {selectedSession &&
                            handleShowSessionInfo()
                        }
                    </div>
                </div>
            </div>
        </LoggedInLayoutSelector>
    )

    function handleShowSessionInfo() {
        return (
            <>
                <div className="flex flex-row p-2">
                    {selectedSession?.SessionTimeStamp.toDate().toDateString()}
                </div>
                <div className="m-1">
                    <div className="cal-session-nohover cal-time w-[100px] text-center">Session</div>
                </div>
                <div className="flex flex-col pl-4">
                    <div className="flex flex-row">
                        <div className="flex flex-row">
                            <LabelText label={"Tutor Name"} value={selectedSession?.TutorName}></LabelText>
                            <div className="p-4 ml-4"> <button className="primary-button" onClick={handleMessageInfoTutor}><FontAwesomeIcon icon={faEnvelope} title="Message"/></button></div>
                        </div>
                        <div className="flex flex-row">
                            <LabelText label={"Student Name"} value={selectedSession?.StudentName}></LabelText>
                            <div className="p-4 ml-4"> <button className="primary-button" onClick={handleMessageInfoUser}><FontAwesomeIcon icon={faEnvelope} title="Message"/></button></div>
                        </div>
                    </div>
                    <LabelText label={"Subject"} value={getSubjectName(selectedSession?.SubjectId ?? "") ?? ""}></LabelText>
                    <div className="flex flex-row">
                        <LabelText label={"Time Slot"} value={selectedSession?.Day + " " + getTimeSlotFromAndTo(selectedSession?.TimeSlotIndex96 ?? -1, selectedSession?.Duration48 ?? 0)}></LabelText>
                        <div className="ml-6"> <LabelText label={"Duration"} value={getDurationText(selectedSession?.Duration48 ?? -1)}></LabelText></div>
                    </div>
                </div>
                <div className="flex flex-col m-4 grow">
                    <label className="cal-header">
                        <span>Shared Notes</span>
                    </label>
                    <textarea className="basic-form-box grow" name="messageText" placeholder="" value={selectedSession?.Notes} ></textarea>
                
                    <div className="flex flex-row-reverse border border-r-0 border-l-0 border-b-0 pl-4 pt-2">
                        {selectedSession?.TutorCanceled || selectedSession?.StudentCanceled ?
                            <>
                                <div className="cal-header p-4"><StatusTag statusText="This session has been suspended" statusTagColor={StatusTagColor.Yellow} tagSize={TagSize.Small}/></div>
                            </>
                            : 
                            <>
                                <div className="cal-header p-6">Session will go ahead!</div>
                            </>
                        }
                    </div>
                </div>
            </>
        )
    }
}